import { createStyles, getStylesRef } from '@mantine/core';

export const useTeamSideBarItemStyle = createStyles(
	(theme, { open }: { open: boolean }) => ({
		displayOnHover: {
			ref: getStylesRef('displayOnHover'),
			opacity: 0,
		},
		chevron: {
			transform: open ? 'rotate(90deg)' : 'none',
			transition: 'transform 100ms ease',
			color: theme.other.getColor('icon/secondary/default'),
		},
		wrapper: {
			width: '100%',
			height: theme.other.space[7],
			paddingRight: 0,
		},
		innerWrapper: {
			width: '100%',
			justifyContent: 'space-between',
			alignItems: 'center',
			borderRadius: theme.other.borderRadius.sm,
			':hover': {
				backgroundColor: theme.other.getColor('fill/transparent/hover'),
			},
			':active': {
				backgroundColor: theme.other.getColor('fill/transparent/active'),
			},
			[`&:hover .${getStylesRef('displayOnHover')}`]: {
				opacity: 1,
			},
			':hover ': {
				cursor: 'pointer',
			},
			':active ': {
				cursor: 'grabbing',
			},
		},
		clickArea: {
			display: 'flex',
			justifyContent: 'start',
			flex: '1 0 auto',
			gap: theme.other.space[0.5],
			width: '80%',
		},
		hiddenButton: {
			':focus': {
				opacity: 1,
			},
		},
		nonButtonParent: {
			[`&:hover.${getStylesRef('displayOnHover')}`]: {
				opacity: 1,
			},
		},
	})
);
